/**
 * 用于减少重复的条件判断，提升性能
 */

export type SupportedLanguage = 'en' | 'zh-CN' | 'zh-HK'

export interface LocalizedTexts {
  en: string
  'zh-CN': string
  'zh-HK': string
}

export const getLocalizedText = (lng: string, texts: LocalizedTexts): string => {
  const language = lng as SupportedLanguage
  return texts[language] || texts['zh-CN']
}

export const getLocalizedCategoryName = (lng: string, categoryItem: any): string => {
  return getLocalizedText(lng, {
    en: categoryItem.categoryNameEn || categoryItem.categoryNameSc,
    'zh-CN': categoryItem.categoryNameSc,
    'zh-HK': categoryItem.categoryNameTc || categoryItem.categoryNameSc
  })
}

export const getLocalizedPublisherName = (lng: string, publisherItem: any): string => {
  return getLocalizedText(lng, {
    en: publisherItem.publisherNameEn || publisherItem.publisherNameSc,
    'zh-CN': publisherItem.publisherNameSc,
    'zh-HK': publisherItem.publisherNameTc || publisherItem.publisherNameSc
  })
}

export const commonTexts = {
  addToCart: {
    en: 'Add to Cart',
    'zh-CN': '加入购物车',
    'zh-HK': '加入購物車'
  },
  addToCartSuccess: {
    en: 'is successfully added to shopping cart',
    'zh-CN': '已成功加入购物车',
    'zh-HK': '已成功加入購物車'
  },
  addToWishlist: {
    en: 'Add to Wishlist',
    'zh-CN': '加入心愿单',
    'zh-HK': '加入心願單'
  },
  isPurchased: {
    en: 'is purchased',
    'zh-CN': '已购买',
    'zh-HK': '已購買'
  }
} as const

export const getCommonText = (lng: string, textKey: keyof typeof commonTexts): string => {
  return getLocalizedText(lng, commonTexts[textKey])
}
